import {
  faFacebookSquare,
  faInstagramSquare,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { PropsWithRef } from "react";
import { CSSProp } from "styled-components";
import tw, { styled } from "twin.macro";

const Wrapper = styled.div<{ grayIcons?: boolean }>`
  ul {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 14px;
    white-space: nowrap;
    margin-bottom: 0;
  }

  li {
    margin-bottom: 0 !important;
  }

  a {
    ${tw`flex`}

    ${(props) =>
      props.grayIcons ? tw`text-theme-gray-7` : tw`text-theme-blue-1!`}

    transition: opacity 0.15s ease;

    &:hover {
      opacity: 0.8;
    }
  }
`;

interface SocialLinksProps {
  css?: CSSProp;
  grayIcons?: boolean;
}

const SocialLinks: React.FunctionComponent<PropsWithRef<SocialLinksProps>> = (
  props
) => (
  <Wrapper {...props}>
    <ul className="list-reset">
      <li>
        <a
          href="https://www.linkedin.com/company/prosperstack"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="LinkedIn"
        >
          <FontAwesomeIcon icon={faLinkedin} size="lg" />
        </a>
      </li>
      <li>
        <a
          href="https://www.facebook.com/ProsperStack"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
        >
          <FontAwesomeIcon icon={faFacebookSquare} size="lg" />
        </a>
      </li>
      <li>
        <a
          href="https://www.instagram.com/prosperstack/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
        >
          <FontAwesomeIcon icon={faInstagramSquare} size="lg" />
        </a>
      </li>
    </ul>
  </Wrapper>
);

export default SocialLinks;
